<template>
  <BlocoFormularioCadastro voltar="/" @salvar="salvar()">
    <template #toolbar>
      <Dropdown dropup>
        <button
          data-test-id="button-auto-1"
          data-role="trigger"
          class="btn btn-info btn-lg dropdown-toggle"
          type="button"
        >
          <span class="fa fa-plus" /> Adicionar <span class="caret" />
        </button>
        <template #dropdown>
          <li
            ><a
              v-if="agendaDia('Segunda')"
              data-test-id="a-adicionardiasemana-2"
              href="#"
              @click.prevent="adicionarDiaSemana('Segunda')"
              >Segunda</a
            ></li
          >
          <li
            ><a
              v-if="agendaDia('Terça')"
              data-test-id="a-adicionardiasemana-3"
              href="#"
              @click.prevent="adicionarDiaSemana('Terça')"
              >Terça</a
            ></li
          >
          <li
            ><a
              v-if="agendaDia('Quarta')"
              data-test-id="a-adicionardiasemana-4"
              href="#"
              @click.prevent="adicionarDiaSemana('Quarta')"
              >Quarta</a
            ></li
          >
          <li
            ><a
              v-if="agendaDia('Quinta')"
              data-test-id="a-adicionardiasemana-5"
              href="#"
              @click.prevent="adicionarDiaSemana('Quinta')"
              >Quinta</a
            ></li
          >
          <li
            ><a
              v-if="agendaDia('Sexta')"
              data-test-id="a-adicionardiasemana-6"
              href="#"
              @click.prevent="adicionarDiaSemana('Sexta')"
              >Sexta</a
            ></li
          >
          <li
            ><a
              v-if="agendaDia('Sábado')"
              data-test-id="a-adicionardiasemana-7"
              href="#"
              @click.prevent="adicionarDiaSemana('Sábado')"
              >Sábado</a
            ></li
          >
          <li
            ><a
              v-if="agendaDia('Domingo')"
              data-test-id="a-adicionardiasemana-8"
              href="#"
              @click.prevent="adicionarDiaSemana('Domingo')"
              >Domingo</a
            ></li
          >
        </template>
      </Dropdown>
    </template>
    <template #form>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div id="filter-panel" class="filter-panel">
            <div class="panel panel-primary">
              <div class="panel-heading"> Filtro </div>
              <div class="panel-body">
                <form novalidate>
                  <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">
                      <div
                        :class="{ 'has-error': v$.filtro.unidade.$error }"
                        class="form-group"
                      >
                        <label for="unidade">Unidade </label>
                        <select
                          id="unidade"
                          v-model="filtro.unidade"
                          data-test-id="select-unidade"
                          class="form-control"
                          @change="aoAlterarUnidade"
                        >
                          <option
                            v-for="unidade in unidades"
                            :key="unidade._id"
                            :value="unidade.nome"
                            >{{ unidade.nome }}</option
                          >
                        </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                      <div
                        :class="{ 'has-error': v$.filtro.especialidade.$error }"
                        class="form-group"
                      >
                        <label for="especialidade">Especialidade </label>
                        <select
                          id="especialidade"
                          v-model="filtro.especialidade"
                          data-test-id="select-especialidade"
                          class="form-control"
                          @change="aoAlterarEspecialidade"
                        >
                          <option
                            v-for="especialidade in especialidades"
                            :key="especialidade.id"
                            :value="especialidade.nome"
                            >{{ especialidade.nome }}</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="panel-group">
            <div
              v-for="(agenda, index) in agendas"
              :key="agenda._id"
              class="panel panel-primary"
            >
              <div class="panel-heading">
                <div class="row">
                  <div
                    class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
                    role="button"
                    @click="toggleAccordion(index)"
                  >
                    <h4>{{ agenda.horarios.dia_semana }}</h4>
                  </div>
                  <div class="pull-right col-xs-4 col-sm-4 col-md-2 col-lg-2">
                    <div class="input-group input-group-sm">
                      <span class="input-group-addon">SLOT</span>
                      <input
                        id="quantidade"
                        v-model.number="agenda.horarios.quantidade"
                        v-mask="'99'"
                        data-test-id="input-quantidade"
                        type="text"
                        name="quantidade"
                        class="form-control campo-quantidade"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <Collapse v-model="showAccordion[index]">
                <div class="panel-body" style="padding: 0; margin: 0">
                  <table class="table table-striped">
                    <tbody>
                      <tr>
                        <td class="turno-tabela">Manhã </td>
                        <td>
                          <span
                            v-for="hora in agenda.horarios.horas"
                            :key="hora.hora"
                          >
                            <span
                              v-if="matutino(hora)"
                              class="input-group input-group-sm campo-hora"
                              style="display: inline-flex; margin: 10px"
                            >
                              <input
                                v-mask="'99:99'"
                                data-test-id="input-auto-4"
                                :class="{ 'campo-hora-dirty': hora.dirty }"
                                :value="hora.hora"
                                type="text"
                                class="form-control campo-hora-valor"
                                @input="aoAtualizarHora(agenda, hora, $event)"
                              />
                              <span class="input-group-btn">
                                <button
                                  data-test-id="button-removerhora-5"
                                  type="button"
                                  class="btn btn-primary"
                                  @click="removerHora(agenda, hora)"
                                >
                                  <span class="fa fa-times" />
                                </button>
                              </span>
                            </span>
                          </span>
                          <button
                            data-test-id="button-adicionarmatutino-6"
                            type="button"
                            class="btn btn-success btn-sm"
                            style="margin-top: -4px"
                            @click="adicionarMatutino(agenda)"
                          >
                            <span class="fa fa-plus" /> Adicionar
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td class="turno-tabela">Tarde </td>
                        <td>
                          <span
                            v-for="hora in agenda.horarios.horas"
                            :key="hora.hora"
                          >
                            <span
                              v-if="vespertino(hora)"
                              class="input-group input-group-sm"
                              style="display: inline-flex; margin: 10px"
                            >
                              <input
                                v-mask="'99:99'"
                                data-test-id="input-auto-7"
                                :class="{ 'campo-hora-dirty': hora.dirty }"
                                :value="hora.hora"
                                type="text"
                                class="form-control campo-hora-valor"
                                @input="aoAtualizarHora(agenda, hora, $event)"
                              />
                              <span class="input-group-btn">
                                <button
                                  data-test-id="button-removerhora-8"
                                  type="button"
                                  class="btn btn-primary"
                                  @click="removerHora(agenda, hora)"
                                >
                                  <span class="fa fa-times" />
                                </button>
                              </span>
                            </span>
                          </span>
                          <button
                            data-test-id="button-adicionarvespertino-9"
                            type="button"
                            class="btn btn-success btn-sm"
                            style="margin-top: -4px"
                            @click="adicionarVespertino(agenda)"
                          >
                            <span class="fa fa-plus" /> Adicionar
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td class="turno-tabela">Noite</td>
                        <td>
                          <span
                            v-for="hora in agenda.horarios.horas"
                            :key="hora.hora"
                          >
                            <span
                              v-if="noturno(hora)"
                              class="input-group input-group-sm"
                              style="display: inline-flex; margin: 10px"
                            >
                              <input
                                v-mask="'99:99'"
                                data-test-id="input-auto-10"
                                :class="{ 'campo-hora-dirty': hora.dirty }"
                                :value="hora.hora"
                                type="text"
                                class="form-control campo-hora-valor"
                                @input="aoAtualizarHora(agenda, hora, $event)"
                              />
                              <span class="input-group-btn">
                                <button
                                  data-test-id="button-removerhora-11"
                                  type="button"
                                  class="btn btn-primary"
                                  @click="removerHora(agenda, hora)"
                                >
                                  <span class="fa fa-times" />
                                </button>
                              </span>
                            </span>
                          </span>
                          <button
                            data-test-id="button-adicionarnoturno-12"
                            type="button"
                            class="btn btn-success btn-sm"
                            style="margin-top: -4px"
                            @click="adicionarNoturno(agenda)"
                          >
                            <span class="fa fa-plus" /> Adicionar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import { Collapse, Dropdown } from 'uiv'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import { useMenu } from '@/composables/useMenu'
import AgendaServico from '@/servicos/AgendaServico'
import EspecialidadeServico from '@/servicos/EspecialidadeServico'
import UnidadeServico from '@/servicos/UnidadeServico'

const unidadeServico = new UnidadeServico()
const especialidadeServico = new EspecialidadeServico()
const agendaServico = new AgendaServico()
const meioDia = moment('12:00', 'HH:mm')
const seisDaTarde = moment('18:00', 'HH:mm')

export default {
  components: { BlocoFormularioCadastro, Collapse, Dropdown },
  directives: { mask: AwesomeMask },

  setup() {
    useMenu(15)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      agendas: [],
      unidades: [],
      especialidades: [],
      showAccordion: [true, false, false, false, false, false, false],
      filtro: {
        unidade: '',
        especialidade: '',
      },
    }
  },
  created() {
    this.recuperarUnidades()
    this.recuperarEspecialidades()
  },
  methods: {
    aoAlterarUnidade() {
      this.v$.filtro.unidade.$touch()
      this.pesquisar()
    },
    aoAlterarEspecialidade() {
      this.v$.filtro.especialidade.$touch()
      this.pesquisar()
    },
    aoAtualizarHora(agenda, hora, event) {
      this.atualizaHora(agenda, hora, event.target.value)
    },
    agendaDia(dia) {
      return !this.agendas.find((a) => a.horarios.dia_semana === dia)
    },
    ordernarHoras(agenda) {
      agenda.horarios.horas.sort((hora1, hora2) => {
        const h1 = moment(hora1.hora, 'HH:mm')
        const h2 = moment(hora2.hora, 'HH:mm')
        if (h1.isBefore(h2)) {
          return -1
        } else if (h1.isAfter(h2)) {
          return 1
        } else {
          return 0
        }
      })
    },
    atualizaHora(agenda, hora, value) {
      const h = moment(value, 'HH:mm')

      if (value.length === 5 && h.isValid()) {
        hora.hora = value
        hora.dirty = true
        this.ordernarHoras(agenda)
      }
    },
    adicionarDiaSemana(dia) {
      this.agendas.push({
        unidade: this.filtro.unidade,
        especialidade: this.filtro.especialidade,
        horarios: {
          dia_semana: dia,
          horas: [],
        },
      })
    },
    toggleAccordion(index) {
      if (this.showAccordion[index]) {
        this.showAccordion[index] = false
      } else {
        for (let i = 0; i < this.showAccordion.length; i++) {
          this.showAccordion[i] = false
        }
        this.showAccordion[index] = true
      }
      this.showAccordion = this.showAccordion.map((v) => v)
    },
    adicionarMatutino(agenda) {
      agenda.horarios.horas.push({
        hora: '',
        quantidade: agenda.horarios.quantidade,
        dirty: true,
        turno: 1,
      })
    },
    adicionarVespertino(agenda) {
      agenda.horarios.horas.push({
        hora: '',
        quantidade: agenda.horarios.quantidade,
        dirty: true,
        turno: 2,
      })
    },
    adicionarNoturno(agenda) {
      agenda.horarios.horas.push({
        hora: '',
        quantidade: agenda.horarios.quantidade,
        dirty: true,
        turno: 3,
      })
    },
    removerHora(agenda, hora) {
      const index = agenda.horarios.horas.indexOf(hora)
      agenda.horarios.horas.splice(index, 1)
    },
    matutino(hora) {
      const h = moment(hora.hora, 'HH:mm')
      return h.isBefore(meioDia) || hora.turno === 1
    },
    vespertino(hora) {
      const h = moment(hora.hora, 'HH:mm')
      return (
        (h.isSameOrAfter(meioDia) && h.isBefore(seisDaTarde)) ||
        hora.turno === 2
      )
    },
    noturno(hora) {
      const h = moment(hora.hora, 'HH:mm')
      return h.isSameOrAfter(seisDaTarde) || hora.turno === 3
    },
    salvar() {
      const agendaResultado = {
        _id: this.agendas[0]._id,
        unidade: this.agendas[0].unidade,
        especialidade: this.agendas[0].especialidade,
        horarios: [],
      }

      this.agendas.forEach((agenda) => {
        agenda.horarios.horas.forEach((hora) => {
          hora.quantidade = agenda.horarios.quantidade
        })

        agendaResultado.horarios.push({
          dia_semana: agenda.horarios.dia_semana,
          horas: agenda.horarios.horas,
        })
      })

      if (agendaResultado._id) {
        agendaServico
          .atualizarAgenda(agendaResultado._id, agendaResultado)
          .then((result) => {
            this.pesquisar(this.filtro)
          })
      } else {
        agendaServico.criarAgenda(agendaResultado)
      }
    },
    pesquisar() {
      this.agendas = []
      agendaServico.recuperarAgendas(this.filtro).then((result) => {
        this.agendas = result.agenda
        this.agendas.forEach((agenda) => {
          agenda.horarios.quantidade = agenda.horarios.horas[0].quantidade
          this.ordernarHoras(agenda)
        })
      })
    },
    recuperarUnidades() {
      unidadeServico.recuperarTodos().then((result) => {
        this.unidades = result.unidades
        this.filtro.unidade = this.unidades[0].nome
        this.pesquisar(this.filtro)
      })
    },
    recuperarEspecialidades() {
      especialidadeServico.recuperarTodos({ ativo: true }).then((result) => {
        this.especialidades = result.especialidades
        this.filtro.especialidade = this.especialidades[0].nome
        this.pesquisar(this.filtro)
      })
    },
  },
  validations: {
    filtro: {
      unidade: { required },
      especialidade: { required },
    },
  },
}
</script>

<style>
.campo-quantidade {
  margin: 0;
  font-weight: 600;
  color: #008080;
  text-align: center;
  border: none;
  box-shadow:
    inset 0 0 8px rgba(0, 0, 0, 0.1),
    0 0 16px rgba(0, 0, 0, 0.1);
}

.campo-hora {
  display: inline-flex;
  margin: 10px;
}

.campo-hora-valor {
  width: 58px !important;
}

.campo-hora-dirty {
  border: 2px solid #3498db;
  border-radius: 3px;
}

.turno-tabela {
  width: 60px;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle !important;
}

.table {
  margin-bottom: 0;
}

.dropdown {
  display: inline-block;
}
</style>
